module.exports = __webpack_public_path__ + "img/中国.e419ba63.png";